import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid, TextField, Button, Stack, Avatar, Typography } from '@mui/material';
import { addSubMember } from '../../controllers/memberManagementController';

const CreateSubMemberDialog = ({ open, onClose, memberId, onCreated }) => {
  const [values, setValues] = useState({ FirstName: '', LastName: '', Email: '', PhoneNumber: '', JobTitle: '', Company: '', Sector: '', University: '', HighSchool: '', Address: '', Password: '' });
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (file) {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    }
    setPreviewUrl('');
  }, [file]);

  const handleChange = (k) => (e) => setValues((v) => ({ ...v, [k]: e.target.value }));

  const reset = () => {
    setValues({ FirstName: '', LastName: '', Email: '', PhoneNumber: '', JobTitle: '', Company: '', Sector: '', University: '', HighSchool: '', Address: '', Password: '' });
    setFile(null);
    setPreviewUrl('');
    setLoading(false);
  };

  const handleClose = () => { reset(); onClose?.(); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        MemberId: memberId,
        FirstName: values.FirstName?.trim(),
        LastName: values.LastName?.trim(),
        Email: values.Email,
        PhoneNumber: values.PhoneNumber,
        JobTitle: values.JobTitle,
        Company: values.Company,
        Sector: values.Sector,
        University: values.University,
        HighSchool: values.HighSchool,
        Address: values.Address,
        Password: values.Password,
        ProfilePicture: file || undefined,
      };
      const created = await addSubMember(payload);
      onCreated?.(created);
      handleClose();
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>Yakın Ekle</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}><TextField label="Ad" value={values.FirstName} onChange={handleChange('FirstName')} required fullWidth /></Grid>
            <Grid item xs={12} md={6}><TextField label="Soyad" value={values.LastName} onChange={handleChange('LastName')} required fullWidth /></Grid>
            <Grid item xs={12} md={6}><TextField label="E-posta" value={values.Email} onChange={handleChange('Email')} type="email" fullWidth /></Grid>
            <Grid item xs={12} md={6}><TextField label="Telefon" value={values.PhoneNumber} onChange={handleChange('PhoneNumber')} fullWidth /></Grid>
            <Grid item xs={12} md={6}><TextField label="Ünvan" value={values.JobTitle} onChange={handleChange('JobTitle')} fullWidth /></Grid>
            <Grid item xs={12} md={6}><TextField label="Şirket" value={values.Company} onChange={handleChange('Company')} fullWidth /></Grid>
            <Grid item xs={12} md={6}><TextField label="Sektör" value={values.Sector} onChange={handleChange('Sector')} fullWidth /></Grid>
            <Grid item xs={12} md={6}><TextField label="Üniversite" value={values.University} onChange={handleChange('University')} fullWidth /></Grid>
            <Grid item xs={12} md={6}><TextField label="Lise" value={values.HighSchool} onChange={handleChange('HighSchool')} fullWidth /></Grid>
            <Grid item xs={12}><TextField label="Ev Adresi" value={values.Address} onChange={handleChange('Address')} fullWidth multiline rows={2} /></Grid>
            <Grid item xs={12} md={6}><TextField label="Geçici Şifre" value={values.Password} onChange={handleChange('Password')} fullWidth type="password" required /></Grid>
            <Grid item xs={12} md={6}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Button variant="outlined" component="label">
                  Profil Fotoğrafı Yükle
                  <input type="file" accept="image/*" hidden onChange={(e) => setFile(e.target.files?.[0] || null)} />
                </Button>
                {previewUrl && <Avatar src={previewUrl} sx={{ width: 56, height: 56 }} />}
              </Stack>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>İptal</Button>
          <Button type="submit" variant="contained" disabled={loading}>Ekle</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateSubMemberDialog;






